import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  Goals = 'Goals',
  MonteCarlo = 'MonteCarlo',
  Longevity = 'Longevity',
}

export const queryKeys = {
  monteCarlo: (clientId: string, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.MonteCarlo,
    clientId,
    fpId,
  ],
  longevity: (clientId: number, fpId: string) => [
    QueryFeature.FinancialPlan,
    QueryKey.Longevity,
    clientId,
    fpId,
  ],
};
